import React from "react";
import { StyledExternalRewardWrapper } from "./policies.style";
import { useFormContext } from "react-hook-form";
import Field from "../../../../../formComponents/formFields/field.component";
import get from "lodash/get";

const ExternalReward = ({ options }) => {
  const {
    settings: { fields },
  } = options;
  const {
    register,
    formState: { errors },
  } = useFormContext();

  return (
    <StyledExternalRewardWrapper>
      <div>
        <Field
          {...fields["external_reward_winner_num"]}
          register={register}
          error={get(errors, "external_reward_winner_num")}
        />
        winners will each receive $
        <Field
          {...fields["external_reward_winner_reward"]}
          register={register}
          error={get(errors, "external_reward_winner_reward")}
        />
      </div>
      <div>
        <Field
          {...fields["external_reward_info"]}
          register={register}
          error={get(errors, "external_reward_info")}
        />
      </div>
    </StyledExternalRewardWrapper>
  );
};

export default ExternalReward;
